import React from "react"
import styled from "styled-components"
import {Occasion} from "@irati/types"
import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"

import {IconTypes} from "@irati/ui/src/Icon"
import {IconButton} from "@irati/ui/src/Button"
import isContentKey from "@irati/utils/lang/helpers/isContentKey"
import Tooltip, {Tip} from "./Tooltip"
import {IconWrapper} from "./styled"

interface Props extends InjectIntl {
  occasion: Occasion
  onDelete?: () => void
}

const StyleAction = styled(IconButton)`
  display: flex;
`

const OccasionWrapper = styled.div`
  background: ${({theme}) => theme.colors.greys.white};
  border-radius: 3px;
  border: 1px solid ${({theme}) => theme.colors.greys.light};
  color: ${({theme}) => theme.colors.greys.dark};
  display: flex;
  align-items: center;
  gap: 8px;
  height: 30px;
  padding: 2px 6px;
  text-transform: uppercase;
  width: max-content;
  max-width: 100%;
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    max-width: 300px;
  `}
  ${({theme}) => theme.mediaQueries.minWidthMedia.largeDesktop`
    max-width: 450px;
  `}
`
const TextWrapper = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const OccasionIcon: React.FC<Props> = (props) => {
  const {occasion, formatMessage, onDelete} = props
  if (!occasion || !occasion.icon) {
    return null
  }
  const occasionLabel = occasion.name
  const occasionTag = occasion.tag
  const occasionAlt = occasion.icon.alt
  const occasionHref = occasion.icon.href
  const occasionName = isContentKey(occasionLabel!) ? <FormattedMessage id={occasionLabel} /> : occasionLabel
  const occasionImgAlt = isContentKey(occasionAlt!) ? formatMessage({id: occasionAlt}) : occasionAlt
  const occasionTagValue = isContentKey(occasion.tag!) ? <FormattedMessage id={occasionTag} /> : occasionTag
  return (
    <Tooltip placement="top" tip={<Tip id={`${occasionName}Tooltip`}>{occasionName}</Tip>}>
      <OccasionWrapper>
        <IconWrapper archived={occasion.archived}>
          <img src={occasion.default ? formatMessage({id: occasionHref}) : occasionHref} alt={occasionImgAlt} />
        </IconWrapper>
        <TextWrapper>{occasionTagValue}</TextWrapper>
        {onDelete && <StyleAction onClick={onDelete} icon={IconTypes.cross} size={10} />}
      </OccasionWrapper>
    </Tooltip>
  )
}

export default injectIntl(OccasionIcon)
